import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { getJson } from '@hcr/api/shared'

import type { ProblemDetailsDto, CouponDto } from '../../dtos'
import { CouponDtoSchema } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

export const createCouponsQueryKey = () => ['consumer', 'coupons']

export const createCouponsQuery =
  (baseUrl: string) =>
  <Data = CouponDto[]>(
    params: AuthorizedRequestParams,
    options?: Partial<UseQueryOptions<CouponDto[], ProblemDetailsDto, Data>>
  ) =>
    useQuery<CouponDto[], ProblemDetailsDto, Data>({
      ...options,
      queryKey: createCouponsQueryKey(),
      queryFn: () =>
        getJson({
          headers: createAuthorizationHeader(params.idToken),
          schema: z.array(CouponDtoSchema),
          url: `${baseUrl}/coupons`,
        }),
    })
